import React from "react";
import Card from "./GraphicandVideoDesignServicesCard.js";

const CardsGrid = ({ cardsData, heading }) => {
  return (
    <div className="relative px-8 sm:px-8 lg:px-8 flex flex-col gap-8 text-white py-16 bg-white">
      {/* Floating Blobs */}
      <div className="absolute inset-0 overflow-hidden z-0">
        {" "}
        {/* Adjusted z-index */}
        {/* Blob 1 */}
        <div
          className=" absolute -left-1/4 -top-1/4 w-[200px] h-[200px]  md:w-[400px] md:h-[400px]  lg:w-[750px] lg:h-[650px] rounded-full bg-teal-300 animate-blob opacity-70"
          style={{
            borderRadius: "60% 40% 30% 70% / 30% 60% 40% 70%", // Irregular shape
          }}
        ></div>
        {/* Blob 2 */}
        <div
          className="absolute -right-1/4 -bottom-1/4 w-[300px] h-[300px]  md:w-[600px] md:h-[600px]  lg:w-[650px] lg:h-[650px] rounded-full bg-teal-400 animate-blob animation-delay-2000 opacity-70"
          style={{
            borderRadius: "60% 40% 30% 70% / 30% 60% 40% 70%", // Irregular shape
          }}
        ></div>
        {/* Blob 3 */}
        <div
          className="absolute left-1/3 top-1/3 w-[200px] h-[200px]  md:w-[400px] md:h-[400px]  lg:w-[450px] lg:h-[350px] rounded-full bg-teal-400 animate-blob animation-delay-4000 opacity-70"
          style={{
            borderRadius: "30% 40% 30% 70% / 30% 50% 40% 40%", // Irregular shape
          }}
        ></div>
        {/* Blob 4 */}
        <div
          className="absolute left-1/4 bottom-0 w-[300px] h-[200px]  md:w-[400px] md:h-[400px]  lg:w-[350px] lg:h-[350px] rounded-full bg-blue-300 animate-blob animation-delay-4000 opacity-70"
          style={{
            borderRadius: "60% 40% 30% 70% / 30% 60% 40% 70%", // Irregular shape
          }}
        ></div>
        {/* Blob 5 */}
        <div
          className="absolute right-1/5 bottom-1/4 w-[300px] h-[300px]  md:w-[400px] md:h-[400px]  lg:w-[350px] lg:h-[350px] rounded-full bg-blue-400 animate-blob animation-delay-2500 opacity-70"
          style={{
            borderRadius: "60% 40% 30% 30% / 30% 60% 40% 50%", // Irregular shape
          }}
        ></div>
        {/* Blob 6 */}
        <div
          className="absolute left-3/4 top-0 w-[300px] h-[300px]  md:w-[400px] md:h-[400px]  lg:w-[350px] lg:h-[350px] rounded-full bg-blue-400 animate-blob animation-delay-3500 opacity-70"
          style={{
            borderRadius: "60% 40% 30% 40% / 30% 60% 40% 20%", // Irregular shape
          }}
        ></div>
      </div>

      {/* Heading Section */}
      <p className="text-center font-normal text-teal-500">
        DIVERSE CREATIVE EXPERTISE
      </p>
      <h2 className="text-center text-4xl font-bold mb-12 text-teal-500">
        {heading}
      </h2>

      {/* Cards Grid */}
      <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto z-10">
        {cardsData.map((card, index) => (
          <Card
            key={index}
            title={card.title}
            description={card.description}
            Icon={card.Icon}
            delay={index * 0.1}
          />
        ))}
      </div>
    </div>
  );
};

export default CardsGrid;
